import type { GroupCreateRequest, GroupDto, GroupsListResponse, GroupUpdateRequest } from '../../api/types';
import type { GroupsRepository } from '../../repositories/ApiGroupsRepository';

export class GroupsService {
  constructor(private readonly repo: GroupsRepository) {}

  listGroups(): Promise<GroupsListResponse> {
    return this.repo.listGroups();
  }

  createGroup(params: { payload: GroupCreateRequest }): Promise<GroupDto> {
    return this.repo.createGroup(params);
  }

  updateGroup(params: { groupId: string; payload: GroupUpdateRequest }): Promise<GroupDto> {
    return this.repo.updateGroup(params);
  }

  deleteGroup(params: { groupId: string }): Promise<void> {
    return this.repo.deleteGroup(params);
  }

  inviteToGroup(params: { groupId: string; telegramIds: number[] }): Promise<GroupDto> {
    return this.repo.inviteToGroup(params);
  }

  removeFromGroup(params: { groupId: string; telegramIds: number[] }): Promise<GroupDto> {
    return this.repo.removeFromGroup(params);
  }

  confirmGroup(params: { groupId: string }): Promise<GroupDto> {
    return this.repo.confirmGroup(params);
  }

  leaveGroup(params: { groupId: string }): Promise<GroupDto> {
    return this.repo.leaveGroup(params);
  }

  joinGroup(params: { groupId: string }): Promise<GroupDto> {
    return this.repo.joinGroup(params);
  }
}
